import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

const StyledUl = styled.ul`
  > li {
    margin-top: -1px;
    margin-left: -1px;
  }
`;

const CategoryItemContainer: FC<PropsWithChildren> = ({
  children,
}): JSX.Element => {
  return (
    <StyledUl className="grid grid-cols-2 laptop:grid-cols-4">
      {children}
    </StyledUl>
  );
};

export default CategoryItemContainer;
